/**
 * Register prices come from GET signup_addons (stripe_plans + signup_discounts).
 * Cloud/Security are gated by API requires_slug (parent fflboss). Never trust client dollar amounts for billing.
 */
import React from 'react';
import Select from "react-select";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import {Button, ButtonGroup, Card} from "reactstrap";
import {CardElement, injectStripe, Elements, StripeProvider} from 'react-stripe-elements';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import APPCONFIG from 'constants/Config';
import API from '@beardeddevops/react.api';
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import {Collections, Objects, Parts} from "../../../components";
import InputAdornment from "@material-ui/core/InputAdornment";
import CardActions from "@material-ui/core/CardActions";
import {CardContent, makeStyles} from "@material-ui/core";
import UniversalModalOverride from "components/UniversalModalOverride";
import SignupAddOns, {getAddOnPrice} from "components/Parts/SignupAddOns";

export default class Register extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Accounts_Create._name);
		this.model.requestType = API.RequestType.CREATE;

		this.state.step = 0;
		this.state.states = [];
		this.state.processors = [];
		this.state.quantity = 0;
		this.state.loading = false;
		this.state.selectedPlan = null;
		this.state.selectedAddOns = [];
		this.state.signupAddOnsAvailable = true;
		this.state.signupPlans = {};
		this.state.bundleDiscounting = true;
		this.state.bundleDiscount = null;
		this.state.fflboss_addon = false;
		this.state.fflboss_plan = null;
		this.state.fflboss_plan_error = '';
		this.state.showPassword = false;
		this.state.showPasswordRetype = false;
		this.brand = APPCONFIG.brand;
		this.redirect = "/locations"
	}

	async componentDidMount() {
		super.componentDidMount();
		this.applyQueryParams();
		this.state.tos = false;
		let processors = new API.BuildClass(Types.Processors._name, API.RequestType.READ_ALL);
		processors = await processors.submit(null, 'GET_ALL');
		processors = processors.items;
		this.setState({processors});
		SignupAddOns.preload().then((signupAddOns) => {
			const pricing = SignupAddOns.preloadedPricing || {};
			this.setState({
				signupAddOnsAvailable: SignupAddOns.preloadError || (Array.isArray(signupAddOns) && signupAddOns.length > 0),
				signupPlans: pricing.plans || {},
				bundleDiscounting: pricing.bundle_discounting !== false,
				bundleDiscount: pricing.bundle_discount || null
			});
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const watchedKeys = ['showPassword', 'showPasswordRetype'];
		if (watchedKeys.some(key => prevState[key] !== this.state[key])) {
			this.setState({ key: Math.random() });
		}
	}

	/**
	 * Prefill register fields from query params, e.g. ?name_first=Mason&email=a@b.com
	 * Applies any present fillable fields independently (does not require all of them).
	 */
	applyQueryParams = () => {
		const urlParams = new URLSearchParams(window.location.search);
		if ([...urlParams.keys()].length === 0) {
			return;
		}

		const stringFields = [
			'name_first',
			'name_last',
			'email',
			'phone',
			'name',
			'store_number',
			'description',
			'street_1',
			'street_2',
			'city',
			'state',
			'zip',
			'tax_rate_state',
			'tax_rate_county',
			'tax_rate_city',
			'tax_rate_special',
			'ffl',
			'name_company',
			'name_legal',
			'ffl_boss_email',
			'reference_id',
		];

		const nextState = {};
		stringFields.forEach((field) => {
			const value = urlParams.get(field);
			if (value !== null && value !== '') {
				nextState[field] = value;
			}
		});

		const quantity = urlParams.get('quantity');
		if (quantity !== null && quantity !== '') {
			const parsed = parseInt(quantity, 10);
			if (!Number.isNaN(parsed)) {
				nextState.quantity = parsed;
			}
		}

		const processor = urlParams.get('processor');
		if (processor !== null && processor !== '') {
			const parsed = parseInt(processor, 10);
			if (!Number.isNaN(parsed)) {
				nextState.processor = parsed;
			}
		}

		const selectedPlan = urlParams.get('selectedPlan') || urlParams.get('plan');
		if (selectedPlan === 'cash_only' || selectedPlan === 'one_terminal' || selectedPlan === 'tacticalpay') {
			nextState.selectedPlan = selectedPlan;
		}

		const fflbossPlan = urlParams.get('fflboss_plan');
		if (fflbossPlan !== null && fflbossPlan !== '') {
			nextState.fflboss_plan = fflbossPlan;
		}

		const fflbossAddon = urlParams.get('fflboss_addon');
		if (fflbossAddon !== null) {
			nextState.fflboss_addon = ['1', 'true', 'yes'].includes(String(fflbossAddon).toLowerCase());
		}

		if (Object.keys(nextState).length > 0) {
			this.setState(nextState);
		}
	}

	handleNext = () => {
		let shouldContinue = API.Validator.process(this, this.requestType, true, null, this.state.step + 1);
		let doesPasswordsMatch = this.state.password === this.state.password_re;
		if (!doesPasswordsMatch) {
			this.setState({ password_re_error: "Passwords must match" });
		}
		if ((shouldContinue || APPCONFIG.settings.isDev()) && doesPasswordsMatch) {
			this.setState({"step": this.state.step + 1});
		}
	};

	handlePrevious = () => {
		this.setState({"step": this.state.step - 1});
	};

	loadFFL = (ffl) => {
		this.setState({
			ffl: ffl.ffl,
			name_company: ffl.name_business ? ffl.name_business : ffl.name_license,
			name_legal: ffl.name_business ? ffl.name_license : '',
			street_1: ffl.street,
			city: ffl.city,
			state: ffl.state,
			zip: ffl.zip.substring(0, 5)
		});
	};

	handleSubmit = async event => {

		if (typeof event !== 'undefined') event.preventDefault();
		if (this.state.loading) {
			return false;
		}
		const selectedAddOns = Array.isArray(this.state.selectedAddOns) ? this.state.selectedAddOns : [];
		const hasFflBoss = selectedAddOns.some((addOn) => addOn && addOn.value === 'fflboss');
		if (hasFflBoss && (!this.state.ffl || !this.state.name_company)) {
			this.setState({
				ffl_error: this.state.ffl ? '' : 'FFL is required when FFL Boss Plus is selected.',
				name_company_error: this.state.name_company ? '' : 'Company name is required when FFL Boss Plus is selected.'
			});
			return false;
		}
		this.setState({loading: true});
		if (await this.handleProcess(null, null)) {
			try {
				await this.submitCreateRequest();

				try {
					await this.handlePlanSelection();
				} catch (e) {
					console.error('Post-signup billing setup failed after account creation.', e);
				}
			} catch (e) {
				this.setState({loading: false});
				return false;
			}
			this.props.history.push('/dashboard');
		} else {
			this.setState({loading: false});
		}
		return false;
	};

	submitCreateRequest = async () => {
		let requestObject = this.model.buildRequestObject(this, API.RequestType.CREATE);
		const selectedAddOns = Array.isArray(this.state.selectedAddOns) ? this.state.selectedAddOns : [];
		const hasFflBoss = selectedAddOns.some((addOn) => addOn && addOn.value === 'fflboss');
		const fflBossAddOn = selectedAddOns.find((addOn) => addOn && addOn.value === 'fflboss');
		requestObject.object.is_tactical = !!window.isTacticalPay;
		requestObject.object.selectedAddOns = selectedAddOns.map((addOn) => ({
			value: addOn.value,
			slug: addOn.value,
			module_pkey: addOn.modulePkey || null,
			stripe_plan_id: addOn.stripePlanId || null
		}));
		requestObject.object.selectedPlan = this.state.selectedPlan;
		requestObject.object.signup_url = typeof window !== 'undefined' ? window.location.href : '';
		requestObject.object.fflboss_addon = hasFflBoss;
		requestObject.object.fflboss_plan = hasFflBoss ? (fflBossAddOn && fflBossAddOn.stripePlanId) || this.state.fflboss_plan || 'ffl_plus' : null;
		requestObject.object.ffl = hasFflBoss ? (this.state.ffl || null) : null;
		requestObject.object.name_company = hasFflBoss ? (this.state.name_company || null) : null;
		requestObject.object.name_legal = hasFflBoss ? (this.state.name_legal || null) : null;

		let message = {
			url: API.URL + '/' + API.Version + requestObject.url,
			type: requestObject.requestType,
			data: {
				object: JSON.stringify(requestObject.object)
			},
			contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
			processData: true,
		};

		let result = await $.ajax(message);
		this.model.onSuccess(false, null, requestObject.requestType)(result);
		this.model.onComplete(this)({status: 200});
		return result && result.response ? result.response : null;
	};

	handlePlanSelection = async () => {
		const billingRoute = this.state.selectedPlan === 'cash_only'
			? 'create_stripe_cash'
			: 'create_stripe_terminal';
		const selectedAddOns = Array.isArray(this.state.selectedAddOns) ? this.state.selectedAddOns : [];
		const hasFflBoss = selectedAddOns.some((addOn) => addOn && addOn.value === 'fflboss');
		const fflBossAddOn = selectedAddOns.find((addOn) => addOn && addOn.value === 'fflboss');
		const billingData = {
			selected_plan: this.state.selectedPlan,
			selected_addons: selectedAddOns.map((addOn) => addOn.value).join(','),
			signup_url: typeof window !== 'undefined' ? window.location.href : ''
		};
		if (hasFflBoss) {
			billingData.fflboss_plan = (fflBossAddOn && fflBossAddOn.stripePlanId) || this.state.fflboss_plan || 'ffl_plus';
		}

		await $.ajax({
			url: `${API.URL}/${API.Version}/accounts/billing/${billingRoute}`,
			type: 'GET',
			data: billingData,
		});
	};

	getPlanPrice = (slug, fallback) => {
		const plan = this.state.signupPlans && this.state.signupPlans[slug];
		if (plan && plan.price != null) {
			return getAddOnPrice(plan.price);
		}
		return fallback;
	};

	getTerminalDisplayPrice = () => {
		const full = this.getPlanPrice('one_terminal', 100);
		const hasFflBoss = (this.state.selectedAddOns || []).some((addOn) => addOn && addOn.value === 'fflboss');
		const discount = this.state.bundleDiscount;
		if (hasFflBoss && this.state.bundleDiscounting && discount && Number(discount.amount) > 0) {
			return Math.max(0, full - Number(discount.amount));
		}
		return full;
	};

	handleSelectedAddOnsChange = (selectedAddOns) => {
		const hasFflBoss = (selectedAddOns || []).some((addOn) => addOn && addOn.value === 'fflboss');
		const fflBossAddOn = (selectedAddOns || []).find((addOn) => addOn && addOn.value === 'fflboss');
		this.setState({
			selectedAddOns,
			fflboss_addon: hasFflBoss,
			fflboss_plan: hasFflBoss ? (fflBossAddOn && fflBossAddOn.stripePlanId) || 'ffl_plus' : null,
			fflboss_plan_error: ''
		});
	};

	handleSignupPricingChange = (pricing) => {
		if (!pricing) {
			return;
		}
		this.setState({
			signupPlans: pricing.plans || {},
			bundleDiscounting: pricing.bundle_discounting !== false,
			bundleDiscount: pricing.bundle_discount || null
		});
	};

	render() {
		let price = this.state.quantity > 0 ? (((this.state.quantity - 1) * 50) + 100) : 50;

		let brand = this.brand;
		let step = this.state.step;
		let steps = ['Account Setup', 'Store Information', 'Plan Details'];

		/** @type {Accounts_Create_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Create_Object} object */
		let object = this.state;

		const classes = makeStyles((theme) => ({
			root: {
				width: '100%',
			},
			button: {
				marginRight: theme.spacing(1),
			},
			instructions: {
				marginTop: theme.spacing(1),
				marginBottom: theme.spacing(1),
			},
		}));

		const cashPrice = this.getPlanPrice('cash_only', 50);
		const terminalPrice = this.getPlanPrice('one_terminal', 100);
		const extraTerminalPrice = this.getPlanPrice('extra_terminal', 50);
		const terminalDisplayPrice = this.getTerminalDisplayPrice();
		const tacticalPayPrice = this.getPlanPrice('tacticalpay', 99);
		const planOptions = [
			{ value: 'cash_only', label: `Cash Only - $${cashPrice}/mo` },
			{ value: 'one_terminal', label: `1 Terminal Connection - $${terminalDisplayPrice}/mo` }
		];
		const registerSelectStyles = {
			container: (provided) => ({...provided, width: '100%'}),
			menuPortal: (provided) => ({...provided, zIndex: 9999}),
		};
		const hasFflBoss = (this.state.selectedAddOns || []).some((addOn) => addOn && addOn.value === 'fflboss');
		const showSignupAddOns = object.signupAddOnsAvailable;
		const isTacticalPay = window.isTacticalPay;
		if (isTacticalPay && this.state.selectedPlan !== 'tacticalpay') {
			this.state.selectedPlan = 'tacticalpay';
		}
		const isFinishDisabled = object.loading || (step === steps.length - 1 && (
			this.state.selectedPlan === null ||
			(hasFflBoss && (!object.ffl || !object.name_company))
		));

		const isMobile = window.innerWidth < 600;

		return (
			<div className="page-signup" style={{
				backgroundColor: '#fff',
				overflowY: 'auto'
			}}>
				<div className="main-body" style={{maxWidth: step === 2 && showSignupAddOns ? '1100px' : '800px'}}>
					<div className="body-inner">
						<Card>
							<CardContent>
								<section className="logo text-center">
									{!isTacticalPay ?
									<h1><a href="/">{brand}</a></h1> :
									<img
										style={{
											maxWidth: '100%',
											height: 'auto',
											display: 'block',
											marginLeft: 'auto',
											marginRight: 'auto'
										}}
										src="/assets/images/tacticalpay_logo.png"
										alt="Tactical Pay"
									/>}
								</section>

								<Stepper orientation={isMobile ? 'vertical' : 'horizontal'} activeStep={step}>
									{steps.map((label, index) => {
										const stepProps = {};
										const labelProps = {};
										return (
											<Step key={label} {...stepProps}>
												<StepLabel {...labelProps}>{label}</StepLabel>
											</Step>
										);
									})}
								</Stepper>

								{step === 0 ?
									<fieldset>
										<h4 style={{textAlign: "center", margin: "0 0 10px"}}>Account Setup</h4>
										<div className="form-group">
											<Framework.Elements.TextField name={"name_first"}
											                              label={"First Name"}
											                              property={properties.name_first}
											                              value={object.name_first}
											                              error={object.name_first_error}
											                              update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField name={"name_last"}
											                              label={"Last Name"}
											                              property={properties.name_last}
											                              value={object.name_last}
											                              error={object.name_last_error}
											                              update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField name={"email"}
											                              label={"Email"}
											                              property={properties.email}
											                              value={object.email}
											                              error={object.email_error}
											                              update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField key={this.state.key}
																		  name={"password"}
											                              label={"Password"}
											                              property={properties.password}
											                              value={object.password}
											                              error={object.password_error}
											                              update={this.handleTextFieldPropertyUpdate}
											                              type={this.state.showPassword ? "text" : "password"}
											                              InputProps={{
												                              endAdornment: (
													                              <i
														                              className={`fa ${this.state.showPassword ? "fa-eye-slash" : "fa-eye"}`}
														                              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
														                              style={{ cursor: "pointer" }}
													                              />
												                              ),
												                              shrink: false
											                              }}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField key={this.state.key}
																		  name={"password_re"}
											                              label={"Retype Password"}
											                              property={properties.password_re}
											                              value={object.password_re}
											                              error={object.password_re_error}
											                              update={this.handleTextFieldPropertyUpdate}
											                              type={this.state.showPasswordRetype ? "text" : "password"}
											                              InputProps={{
												                              endAdornment: (
													                              <i
														                              className={`fa ${this.state.showPasswordRetype ? "fa-eye-slash" : "fa-eye"}`}
														                              onClick={() => this.setState({ showPasswordRetype: !this.state.showPasswordRetype })}
														                              style={{ cursor: "pointer" }}
													                              />
												                              ),
												                              shrink: false
											                              }}
											/>
										</div>
									</fieldset>
									: null}

								{step === 1 ?
									<fieldset>
										<h4 style={{textAlign: "center", margin: "0 0 10px"}}>Store
											Information</h4>
										<div className={"row"}>
											<div className={"col-md"}>
												<div className="form-group">
													<Framework.Elements.TextField
														name={"name"}
														label={"Name"}
														property={properties.name}
														value={object.name}
														error={object.name_error}
														update={this.handleTextFieldPropertyUpdate}
													/>
												</div>
												<div className="form-group">
													<Framework.Elements.TextField
														name={"store_number"}
														label={"Store Number"}
														value={object.store_number}
														error={object.store_number_error}
														property={properties.store_number}
														update={this.handleTextFieldPropertyUpdate}
													/>
												</div>
												<div className="form-group">
													<Framework.Elements.TextField
														name={"description"}
														label={"Description"}
														property={properties.description}
														value={object.description}
														error={object.description_error}
														update={this.handleTextFieldPropertyUpdate}
													/>
												</div>
												<div className="form-group">
													<Framework.Elements.PhoneNumber
														label={"Phone"}
														property={properties.phone}
														value={object.phone}
														error={object.phone_error}
														update={this.handleTextFieldPropertyUpdate}
													/>
												</div>
											</div>
											<div className={"col-md"}>
												<Parts.Address
													object={object}
													properties={properties}
													onTextUpdate={this.handleTextFieldPropertyUpdate}
													onSelectUpdate={this.handleSelectPropertyUpdate}
													hasCounty={false}
												/>
											</div>
										</div>
										<hr/>
										<div className={"row"}>
											<div className={"col-md"}>
												<div className="form-group">
													<Framework.Elements.TextField
														name={"tax_rate_state"}
														label={"State Tax Rate"}
														property={properties.tax_rate_state}
														value={object.tax_rate_state}
														error={object.tax_rate_state_error}
														type={'string'}
														update={this.handleTextFieldPropertyUpdate}
														InputProps={{
															endAdornment: (
																<InputAdornment position={"end"}> <i
																	className="fa fa-percent"/></InputAdornment>
															),
															shrink: false
														}}
													/>
												</div>
												<div className="form-group">
													<Framework.Elements.TextField
														name={"tax_rate_special"}
														label={"Other/Special Tax Rate"}
														property={properties.tax_rate_special}
														value={object.tax_rate_special}
														error={object.tax_rate_state_error}
														update={this.handleTextFieldPropertyUpdate}
														type={"string"}
														InputProps={{
															endAdornment: (
																<InputAdornment position={"end"}> <i
																	className="fa fa-percent"/></InputAdornment>
															),
															shrink: false
														}}
													/>
												</div>
											</div>
											<div className={"col-md"}>
												<div className="form-group">
													<Framework.Elements.TextField
														name={"tax_rate_county"}
														label={"County Tax Rate"}
														property={properties.tax_rate_county}
														value={object.tax_rate_county}
														error={object.tax_rate_county_error}
														update={this.handleTextFieldPropertyUpdate}
														type={"string"}
														InputProps={{
															endAdornment: (
																<InputAdornment position={"end"}> <i
																	className="fa fa-percent"/></InputAdornment>
															),
															shrink: false
														}}
													/>
												</div>
												<div className="form-group">
													<Framework.Elements.TextField

														label={"City Tax Rate"}
														property={properties.tax_rate_city}
														value={object.tax_rate_city}
														error={object.tax_rate_city_error}
														update={this.handleTextFieldPropertyUpdate}
														type={"string"}
														InputProps={{
															endAdornment: (
																<InputAdornment position={"end"}> <i
																	className="fa fa-percent"/></InputAdornment>
															),
															shrink: false
														}}

													/>
												</div>
											</div>
										</div>
									</fieldset>

									: null}

								{step === 2 ?
									<>
									<div className="row">
										<div className={showSignupAddOns ? 'col-md-7' : 'col-md-12'}>
									{isTacticalPay ?
										<fieldset>
											<h4 style={{textAlign: "center", margin: "0 0 10px"}}>Plan Details</h4>
											<hr/>
											<p style={{textAlign: "center", fontSize: "18px"}}>
												<b>${tacticalPayPrice}/mo</b> TacticalPay POS (All-Inclusive)
												<p>Includes full POS software, inventory management, and firearms-specific workflows.<br />
													No long-term contracts. Cancel anytime.</p>
												<p><i>FFLBoss compliance subscription required separately.</i></p>
											</p>

											<b style={{justifyContent: 'center', display: 'flex'}}>You’ll be prompted to enter your billing information to activate your subscription.</b>
											<b style={{justifyContent: 'center', display: 'flex'}}>Your hardware will be pre-configured and paired with your account prior to shipment.</b>

										</fieldset> :
									<fieldset>
										<h4 style={{textAlign: "center", margin: "0 0 10px"}}>Plan Details</h4>
										<hr/>
										<p style={{textAlign: "center", fontSize: "18px"}}>
											<b>${cashPrice}/mo</b> for <i style={{fontSize: "20px", fontStyle: 'italic'}}>Cash Only</i>
											<br/>
											<b>${terminalDisplayPrice}/mo</b> for 1 Terminal connection{terminalDisplayPrice < terminalPrice ? <small style={{color: '#15803d'}}> (normally ${terminalPrice})</small> : null}<br/>
											<b>${extraTerminalPrice}/mo</b> for each additional Terminal connection
										</p>

										<div className="form-group" style={{marginBottom: "20px"}}>
											<Select
												value={planOptions.find(option => option.value === this.state.selectedPlan)}
												onChange={(selectedOption) => {
													this.setState({selectedPlan: selectedOption ? selectedOption.value : null})
												}}
												options={planOptions}
												isClearable
												placeholder={'Select a plan, both include 7 day free trial.'}
												menuPortalTarget={document.body}
												styles={registerSelectStyles}
											/>
										</div>

										<hr/>

										<b style={{justifyContent: 'center', display: 'flex'}}>You will be prompted to set up a Stripe billing subscription upon account creation.</b>
										<b style={{textAlign: 'center', display: 'flex'}}>If you plan to use terminals, you will be able to add your processor API key after account creation.</b>

									</fieldset>
								}
											{hasFflBoss ? (
												<>
													<div className={"row"} style={{marginTop: '16px'}}>
														<div className={"col-8"}>
															<div className="form-group">
																<Framework.Elements.TextField
																	name={"ffl"}
																	label={"FFL"}
																	property={properties.ffl}
																	value={object.ffl}
																	error={object.ffl_error}
																	update={this.handleTextFieldPropertyUpdate}
																	InputProps={{
																		inputComponent: Framework.Masks.FFL,
																	}}
																/>
															</div>
														</div>
														<div className={"col-4"}>
															<Button className="primary-button" onClick={this.toggle('modalFFLLookup')}
																style={{position: 'absolute', right: '18px'}}>
																<i className={"fa fa-search"}/>
																<span className="hidden-xs">&nbsp;&nbsp;FFL Lookup</span>
															</Button>
														</div>
													</div>

													<div className="form-group">
														<Framework.Elements.TextField
															name={"name_company"}
															label={"Company Name"}
															value={object.name_company}
															error={object.name_company_error}
															property={properties.name_company}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>

													<div className="form-group">
														<Framework.Elements.TextField
															name={"name_legal"}
															label={"Company Name Legal"}
															value={object.name_legal}
															error={object.name_legal_error}
															property={properties.name_legal}
															update={this.handleTextFieldPropertyUpdate}
														/>
													</div>

													<UniversalModalOverride
														locations={[]}
														states={[]}
														history={this.props.history}
														name={"FFL Lookup"}
														object={Collections.FFLLookup}
														toggle={this.state.modalFFLLookup}
														reportClose={this.reportClose('modalFFLLookup')}
														afterSave={this.loadFFL}
														size={"xl"}
														hasSubmit={false}
														objectProps={{
															currentFFL: object.ffl
														}}
													/>
												</>
											) : null}
										</div>
										{showSignupAddOns && <div className={"col-md-5"}>
											<SignupAddOns
												selectedAddOns={object.selectedAddOns}
												onSelectedAddOnsChange={this.handleSelectedAddOnsChange}
												onPricingChange={this.handleSignupPricingChange}
												basePlanPrice={isTacticalPay ? tacticalPayPrice : (this.state.selectedPlan === 'cash_only' ? cashPrice : (this.state.selectedPlan === 'one_terminal' ? terminalDisplayPrice : 0))}
												hasBasePlan={!!this.state.selectedPlan}
											/>
										</div>}
									</div>
								</>
									: null}

							</CardContent>
							<CardActions>
								<div style={{width: '100%'}}>
									<div>
										{step === 0 ?
											<Button onClick={() => this.props.history.push('/login')}
											        className={classes.button}
											        disabled={object.loading}>
												Back
											</Button>
											:
											<Button onClick={this.handlePrevious} className={classes.button} disabled={object.loading}>
												Back
											</Button>}
										<Button
											variant="contained"
											disabled={(step === steps.length - 1) && this.state.selectedPlan === null}
											onClick={step === steps.length - 1 ? () => {
												this.handleSubmit().then()
											} : this.handleNext}
											className={`${classes.button} primary-button`}
											style={{'float': 'right'}}
										>
											{step === steps.length - 1 ? 'Finish' : 'Next'}
										</Button>
									</div>
								</div>
							</CardActions>
						</Card>
						{object.loading ? (
							<div style={{
								position: 'fixed',
								top: 0,
								right: 0,
								bottom: 0,
								left: 0,
								background: 'rgba(15, 23, 42, 0.62)',
								zIndex: 10000,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexDirection: 'column'
							}}>
								<div className="spinner-border text-light" style={{width: '3.5rem', height: '3.5rem'}} role="status">
									<span className="sr-only">Loading...</span>
								</div>
								<div style={{color: '#fff', marginTop: 18, fontSize: 18, fontWeight: 700}}>
									Creating your account…
								</div>
							</div>
						) : null}
					</div>
				</div>
			</div>
		);
	}
}
